import "../../styles/HeroModule.css";

const HeroModule = () => {
  const handleScrollClick = () => {
    const nextSection = document.getElementById("ServiceModule");

    if (nextSection) {
      nextSection.scrollIntoView({ behavior: "smooth", block: "start" });
    } else {
      console.error("Services section not found!");
    }
  };

  return (
    <section className="Hero-section bg-secondary">
      <div className="Hero-container">
        <div className="row align-items-center pt-5">
          {/* LEFT SIDE */}
          <div className="col-lg-7 col-md-12 Hero-left">
            <h1 className="Hero-title title">
              Transform Your
              <br />
              <span className="text-accent">Vision</span> Into A <br />
              Pro Product
            </h1>

            <p className="Hero-description sub-title">
              <span className="text-accent hero-description-span">
                Springevening Private Limited
              </span>{" "}
              bring your ideas to life with UI/UX design, mobile and desktop app
              development, website creation, and logo designing. We help you
              build products that are fast, functional, and future-ready.
            </p>
            {/* 
            <button className="Hero-btn text-white">Our Services ↗</button> */}
          </div>

          {/* RIGHT SIDE */}
          <div className="col-lg-5 col-md-12 Hero-right">
            <div className="Hero-visual">
              {/* SVG circle with text and dots */}
              <svg
                width="200"
                height="200"
                viewBox="0 0 200 200"
                className="Hero-circle-svg"
              >
                <defs>
                  <path
                    id="circlePath"
                    d="M 100, 100 m -80, 0 a 80,80 0 1,1 160,0 a 80,80 0 1,1 -160,0"
                  />
                </defs>

                <text
                  fill="#e4da0f"
                  fontWeight="bold"
                  fontSize="22"
                  letterSpacing="3"
                  fontFamily="'Segoe UI', Tahoma, Geneva, Verdana, sans-serif"
                >
                  <textPath
                    href="#circlePath"
                    startOffset="12.5%"
                    lengthAdjust="spacingAndGlyphs"
                    method="align"
                  >
                    Learn, Innovate, Excel
                  </textPath>
                </text>

                {[...Array(5)].map((_, i) => {
                  const startAngle = 450;
                  const angleRange = 110;
                  const angle = startAngle + (i * angleRange) / 4;
                  const radians = (angle * Math.PI) / 180;
                  const cx = 100 + 80 * Math.cos(radians);
                  const cy = 100 + 80 * Math.sin(radians);
                  return (
                    <circle key={i} cx={cx} cy={cy} r="4" fill="#d6e875" />
                  );
                })}
              </svg>

              {/* Blue triangle */}
              <div className="Hero-blue-triangle"></div>

              {/* Image */}
              <img
                src="/assets/heroimage.png"
                alt="Man holding laptop"
                className="Hero-image"
                draggable={false}
              />
            </div>
          </div>
        </div>
      </div>

      {/* Marble-style Scroll Indicator */}
      <div
        className="Hero-scroll-indicator"
        onClick={handleScrollClick}
        role="button"
        aria-label="Scroll to Services"
      >
        <div className="Hero-scroll-thumb" />
      </div>
    </section>
  );
};

export default HeroModule;
